import { useSuspenseQuery } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { SubaccountHome } from '@/components/accounts/SubaccountHome'
import { accountQuery, subaccountsQuery } from '@/lib/queries'

/**
 * A client sub-account's Home — the landing when you enter a client (the default, not Topics). Its
 * Topics workspace stays at `/topics/$subaccountId`; this is a surface above it. The account's own
 * primary sub-account has no page here — it IS the account, whose Home is `/app/accounts/$accountId`.
 */
export const Route = createFileRoute('/app/accounts/$accountId_/subaccounts/$subaccountId/')({
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(accountQuery(params.accountId)),
      context.queryClient.ensureQueryData(subaccountsQuery(params.accountId)),
    ]),
  component: SubaccountHomePage,
})

function SubaccountHomePage() {
  const { accountId, subaccountId } = Route.useParams()
  const { data: account } = useSuspenseQuery(accountQuery(accountId))
  const { data: subsData } = useSuspenseQuery(subaccountsQuery(accountId))
  const subaccount = subsData.subaccounts.find((sub) => sub.id === subaccountId)

  return (
    <div className="flex flex-col gap-6">
      <Link
        to="/app/accounts/$accountId"
        params={{ accountId }}
        className="flex w-fit items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ChevronLeft className="size-3.5" />
        {account.name}
      </Link>
      {subaccount ? (
        <SubaccountHome account={account} subaccount={subaccount} />
      ) : (
        <p className="text-sm text-muted-foreground">This client no longer exists.</p>
      )}
    </div>
  )
}
